<template>
  <div id="footer" v-if="content" v-editable="content">
    <Rgpd />

    <div class="footer-first primary-bg" v-if="checkPage()">
      <Newsletter :title="content.newsletter_title" v-if="!isShop" />
      <Socials :title="content.socials_title" />
    </div>
    <!--  <Gmap :content="content.gmap[0]"/> -->

    <Footer-menu />
  </div>
</template>

<script>
import api from "@/api";
export default {
  name: "custom-footer",
  data() {
    return {
      content: null,
      name: this.$route.meta.title,
      id: this.$route.params.id
    };
  },
  created() {
    this.fetchData();
    if (this.$storyblok) {
      this.$storyblok.init();
      this.$storyblok.on(["change", "published"], () => window.location.reload());
      this.$storyblok.on("input", ({ story }) => {
        this.content = story.content;
      });
    }
  },
  /*mounted() {
    console.log("route", this.$route);
    console.log("meta", this.$route.meta.title);
  },*/
  computed: {
    isShop() {
      return this.$route.name === "shop-page" || this.$route.name === "cart-product";
    }
  },
  methods: {
    async fetchData() {
      try {
        const { data } = await api.get(`cdn/stories/${this.$i18n.locale}/footer`);
        this.content = data.story.content;
      } catch (err) {
        console.log(err);
      }
    },
    checkPage() {
      if (this.$route.meta.title == "nous-trouver") {
        return false;
      }
      return true;
    },
    getMarker(content) {
      let marker = null;
      if (this.id == "ste-foy") {
        this.content.gmap[0].markers[0] = null;
        return this.content.gmap[0];
      } else if (this.id == "albigny") {
        this.content.gmap[0].markers[1] = null;
        return this.content.gmap[0];
      }
    }
  }
};
</script>

<style lang="scss">
#footer {
  position: relative;
  background-color: #fff;
}
.primary-bg {
  background: linear-gradient(135deg, $primary-D 0%, $primary 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  > * {
    padding: 0 50px;
  }
}

@media screen and (max-width: 980px) {
  .primary-bg {
    display: block;
    justify-content: left;
  }
}
</style>
